import { CustomerContext } from 'Components/Homepage';
import { useContext } from 'react';

export function useCustomerContext() {
  const { customer } = useContext(CustomerContext);
  if (!customer) throw new Error('No customer found, should never happend!');

  return customer;
}
